<template>
  <div class="wrapper">
    <div class="wrapper-body">
      <a-form-model ref="apform" :model="form" :rules="rules">
        <a-row :gutter="24">
          <a-col :span="getScreen ? '24' : '12'">
            <a-form-model-item
              ref="dateOfAp"
              label="Date of AP"
              prop="dateOfAp"
            >
              <a-input
                disabled
                v-model="form.dateOfAp"
                @blur="
                  () => {
                    $refs.dateofap.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item ref="invoice" label="No Invoice" prop="invoice">
              <a-input
                v-model="form.invoice"
                disabled
                @blur="
                  () => {
                    $refs.invoice.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item ref="supplier" label="Supplier" prop="supplier">
              <a-input
                v-model="form.supplier"
                disabled
                @blur="
                  () => {
                    $refs.supplier.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-row :gutter="24">
              <a-col :span="getScreen ? 24 : 12">
                <a-form-model-item
                  ref="banknama"
                  label="Bank Name"
                  prop="bank.nama"
                >
                  <a-input
                    v-model="form.bank.nama"
                    disabled
                    @blur="
                      () => {
                        $refs.banknama.onFieldBlur();
                      }
                    "
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="getScreen ? 24 : 12">
                <a-form-model-item
                  ref="norekening"
                  label="Account Bank Number"
                  prop="bank.rekening"
                >
                  <a-input
                    v-model="form.bank.rekening"
                    disabled
                    @blur="
                      () => {
                        $refs.norekening.onFieldBlur();
                      }
                    "
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="getScreen ? '24' : '12'">
            <a-row :gutter="24">
              <a-col :span="getScreen ? 24 : 12">
                <a-form-model-item label="Date of Invoice" prop="dateOfInvoice">
                  <a-date-picker v-model="form.dateOfInvoice" disabled/>
                </a-form-model-item>
              </a-col>
              <a-col :span="getScreen ? 24 : 12">
                <a-form-model-item prop="dueDate">
                  <span slot="label"
                    >Due Date ( {{ dateCalculation }} day/s )</span
                  >
                  <a-date-picker v-model="form.dueDate" disabled/>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-form-model-item label="Credit Card" v-if="form.id_user_cc">
              <a-select
                v-model="form.id_user_cc"
                disabled
              >
                <a-select-option
                  v-for="item in CClist"
                  :key="item.id_user_cc"
                  :value="item.id_user_cc"
                >{{item.no_cc}} | {{item.tlc}}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              ref="description"
              label="Description"
              prop="deskripsi"
            >
              <a-input
                v-model="form.deskripsi"
                @blur="
                  () => {
                    $refs.description.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item ref="note" label="Note" prop="note">
              <a-textarea
                v-model="form.note"
                @blur="
                  () => {
                    $refs.note.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item ref="document" prop="file" label="File Document">
              <a-upload
                v-model="form.file"
                :fileList="fileList"
                :showUploadList="true"
                :beforeUpload="beforeUpload"
                :remove="handleRemoveList"
              >
                <a-button
                  ref="btndocument"
                  :disabled="disabledUpload"
                  icon="upload"
                  >Select File
                </a-button>
              </a-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
export default {
  name: "informasi",
  props: {
    id: String,
    type: String,
  },
  mixins: [GlobalMethod],
  data() {
    let checkPending;
    let checkValue = (rule, value, callback) => {
      clearTimeout(checkPending);
      if (!value) {
        return callback(new Error("Please input the value"));
      }

      const limit = parseFloat(this.form.valueLimit);
      if (value > limit) {
        callback(new Error(`Value must be less than ${this.form.valueLimit}`));
      } else {
        callback();
      }
    };
    return {
      form: {
        file: [],
        dateOfAp: "",
        noTransaksi: "",
        supplier: "",
        bank: {
          nama: "",
          rekening: "",
        },
        deskripsi: "",
        invoice: "",
        dateOfInvoice: "",
        dueDate: "",
        value: 0,
        valueLimit: 0,
        note: "",
        kurs: 1,
        id_user_cc: null
      },
      rules: {
        file: [
          {
            required: true,
          },
        ],
        dateOfAp: [
          {
            required: true,
            message: "Please input Date Of AP",
            trigger: "blur",
          },
        ],
        noTransaksi: [
          {
            required: true,
            message: "Please input Transaction Number",
            trigger: "blur",
          },
        ],
        supplier: [
          {
            required: true,
            message: "Please input Supplier",
            trigger: "blur",
          },
        ],
        bank: {
          nama: [
            {
              required: true,
              message: "Please input Bank Name",
              trigger: "change",
            },
          ],
          rekening: [
            {
              required: true,
              message: "Please input Bank Account",
              trigger: "blur",
            },
          ],
        },
        deskripsi: [
          {
            required: true,
            message: "Please input Description",
            trigger: "blur",
          },
        ],
        invoice: [
          {
            required: true,
            message: "Please input invoice",
            trigger: "blur",
          },
        ],
        dateOfInvoice: [
          {
            required: true,
            message: "Please input date of invoice",
            trigger: "change",
          },
        ],
        dueDate: [
          {
            required: true,
            message: "Please input due date",
            trigger: "change",
          },
        ],
        value: [
          {
            required: true,
            trigger: "blur",
            validator: checkValue,
          },
        ],
        note: [
          {
            required: true,
            message: "Please input note",
            trigger: "blur",
          },
        ],
        kurs: [
          {
            required: true,
            message: "Please input Value exchange rate",
            trigger: "blur",
          },
        ],
      },
      transaksi: {},
      disabledUpload: false,
      po_wo_dtl: [],
      po_wo_dtl_pph: [],
      fileList: [],
      CClist: [],
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getBank",
      "getScreen",
    ]),
    dateCalculation() {
      const today = this.moment().format(this.getDefaultDateFormat);
      const dueDate = this.moment(this.form.dueDate).format(
        this.getDefaultDateFormat
      );

      const todayFormated = this.moment(today, this.getDefaultDateFormat);
      const dueDateFormated = this.moment(dueDate, this.getDefaultDateFormat);
      const calc = dueDateFormated.diff(todayFormated, "days");

      return calc;
    },
  },
  created() {},
  mounted() {
    //console.log(this.type,this.id)
    this.$store
      .dispatch("getCreateAP", {
        auth: this.getAuth,
        params: {
          type: this.type,
          id: this.id,
          url:
            this.$route.name == "account-pay-edit"
              ? "edit"
              : "create_account_pay",
        },
      })
      .then((res) => {
        if (this.$route.name == "account-pay-edit") {
          let detils = res.data.dtl;
          for (let index = 0; index < detils.length; index++) {
            if(detils[index].type_item=='Tax' && detils[index].type_tax.includes('pph')){
              detils[index].id_invoice_ap_ad_dtl = detils[index].powopdtl;
            }else{
              detils[index].powopdtl = detils[index].id_invoice_ap_ad_dtl;
            }
            if (
              detils[index].document_tax != null &&
              detils[index].document_tax != "No File Uploaded"
            ) {
              let typefile = this.fileTypeFromUrl(detils[index].document_tax);
              let file = this.dataURLtoFile(
                typefile + detils[index].document_file,
                detils[index].document_tax
              );
              file.uid = "vc-upload-1-1";
              file.status = "done";
              file.url = this.$serviceUrl + detils[index].document_path;
              detils[index]["attachment"] = file;
            }
          }
          Event.$emit("updateList", { value: detils, type: "delete" });

          //console.log(transaksi);
          this.form = {
            dateOfAp: moment(res.data.header.date_of_ap).format(
              this.getDefaultDateFormat
            ),
            invoice: res.data.header.no_invoice,
            idTransaksi: res.data.header.id_invoice,
            supplier: res.data.header.supplier,
            bank: {
              nama: res.data.header.bank_name,
              rekening: res.data.header.account_bank_number,
            },
            deskripsi: res.data.header.description,
            dateOfInvoice: moment(res.data.header.date_of_invoice),
            dueDate: moment(res.data.header.due_date),
            //valueLimit: transaksi.value,
            note: res.data.header.note,
            mata_uang: res.data.header.currency,
            id_user_cc: res.data.header.id_user_cc
          };

          this.CClist = res.data.user_cc

          if (
            res.data.header.document_name != null &&
            res.data.header.document_name != ""
          ) {
            let typefile = this.fileTypeFromUrl(res.data.header.document_name);
            let file = this.dataURLtoFile(
              typefile + res.data.header.document_file,
              res.data.header.document_name
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + res.data.header.link;
            this.form.file = file;
            this.fileList = [];
            this.fileList.push(file);
          }

          this.po_wo_dtl = res.data.dtl_invoice;
          // let po_wo_dtl_pph = res.data.dtl_po_wo;
          // for (let indexing = 0; indexing < po_wo_dtl_pph.length; indexing++) {
          //   this.po_wo_dtl.push({
          //     bearer_tax: po_wo_dtl_pph[indexing].bearer_tax,
          //     currency: po_wo_dtl_pph[indexing].currency,
          //     id_invoice_ap_ad_dtl: po_wo_dtl_pph[indexing].id,
          //     id_po_wo_dtl: po_wo_dtl_pph[indexing].id,
          //     id_pp_dtl: null,
          //     item: po_wo_dtl_pph[indexing].item,
          //     kategori: po_wo_dtl_pph[indexing].kategori,
          //     nilai: po_wo_dtl_pph[indexing].nilai,
          //     pemakaian: po_wo_dtl_pph[indexing].pemakaian,
          //     qty: po_wo_dtl_pph[indexing].qty,
          //     sisa: po_wo_dtl_pph[indexing].sisa,
          //     sisa_ori: po_wo_dtl_pph[indexing].sisa_ori,
          //     type_tax: po_wo_dtl_pph[indexing].type_tax,
          //     unit_price: po_wo_dtl_pph[indexing].unit_price,
          //   });
          // }

          //add po dtl ke invoice detil khusu pph21
          for (let iz = 0; iz < res.data.dtl_po_wo.length; iz++) {
            this.po_wo_dtl.push({
              bearer_tax: res.data.dtl_po_wo[iz].bearer_tax,
              currency: res.data.dtl_po_wo[iz].currency,
              id_invoice_ap_ad_dtl: res.data.dtl_po_wo[iz].id,
              id_po_wo_dtl: res.data.dtl_po_wo[iz].id,
              id_pp_dtl: res.data.dtl_po_wo[iz].id_pp_dtl_fk,
              item: res.data.dtl_po_wo[iz].item,
              kategori: res.data.dtl_po_wo[iz].kategori,
              nilai: res.data.dtl_po_wo[iz].nilai,
              pemakaian: res.data.dtl_po_wo[iz].pemakaian,
              qty: res.data.dtl_po_wo[iz].qty,
              sisa: res.data.dtl_po_wo[iz].sisa,
              sisa_ori: res.data.dtl_po_wo[iz].sisa_ori,
              type_tax: res.data.dtl_po_wo[iz].type_tax,
              unit_price: res.data.dtl_po_wo[iz].unit_price
            });
          }

          for (let iinv = 0; iinv < this.po_wo_dtl.length; iinv++) {
            if (this.po_wo_dtl[iinv].kategori == "1") {
              this.po_wo_dtl[iinv].kategori = "5";
            } else if (this.po_wo_dtl[iinv].kategori == "0") {
              this.po_wo_dtl[iinv].kategori = "1";
            }
          }
        } else {
          //const transaksi = res.data.no_transaksi[0];
          //console.log(transaksi);

          this.form = {
            dateOfAp: moment().format(this.getDefaultDateFormat),
            invoice: res.data.no_invoice,
            idTransaksi: res.data.id_invoice,
            supplier: res.data.supplier,
            supplierId: res.data.id_supplier,
            bank: {
              nama: res.data.bank_name,
              rekening: res.data.account_bank_number,
            },
            deskripsi: res.data.description,
            dateOfInvoice: moment(res.data.date_of_invoice),
            dueDate: moment(res.data.due_date),
            //valueLimit: transaksi.value,
            note: res.data.note,
            file: [],
            kurs: 1,
            mata_uang: res.data.currency,
            id_user_cc: res.data.id_user_cc
          };

          this.CClist = res.data.user_cc

          this.po_wo_dtl = res.data.dtl_invoice;

          //add po dtl ke invoice detil khusu pph21
          for (let iz = 0; iz < res.data.dtl_po_wo.length; iz++) {
            this.po_wo_dtl.push({
              bearer_tax : res.data.dtl_po_wo[iz].bearer_tax,
              currency : res.data.dtl_po_wo[iz].currency,
              id_invoice_ap_ad_dtl : res.data.dtl_po_wo[iz].id,
              id_po_wo_dtl : res.data.dtl_po_wo[iz].id,
              id_pp_dtl : res.data.dtl_po_wo[iz].id_pp_dtl_fk,
              item : res.data.dtl_po_wo[iz].item,
              kategori : res.data.dtl_po_wo[iz].kategori,
              nilai : res.data.dtl_po_wo[iz].nilai,
              pemakaian : res.data.dtl_po_wo[iz].pemakaian,
              qty : res.data.dtl_po_wo[iz].qty,
              sisa : res.data.dtl_po_wo[iz].sisa,
              sisa_ori : res.data.dtl_po_wo[iz].sisa_ori,
              type_tax : res.data.dtl_po_wo[iz].type_tax,
              unit_price : res.data.dtl_po_wo[iz].unit_price
            });
          }

          for (let iinv = 0; iinv < this.po_wo_dtl.length; iinv++) {
            if (this.po_wo_dtl[iinv].kategori == "1") {
              this.po_wo_dtl[iinv].kategori = "5";
            } else if (this.po_wo_dtl[iinv].kategori == "0") {
              this.po_wo_dtl[iinv].kategori = "1";
            }
          }
          // let po_wo_dtl_pph = res.data.dtl_po_wo;
          // for (let indexing = 0; indexing < po_wo_dtl_pph.length; indexing++) {
          //   this.po_wo_dtl.push({
          //     bearer_tax: po_wo_dtl_pph[indexing].bearer_tax,
          //     currency: po_wo_dtl_pph[indexing].currency,
          //     id_invoice_ap_ad_dtl: po_wo_dtl_pph[indexing].id,
          //     id_po_wo_dtl: po_wo_dtl_pph[indexing].id,
          //     id_pp_dtl: null,
          //     item: po_wo_dtl_pph[indexing].item,
          //     kategori: po_wo_dtl_pph[indexing].kategori,
          //     nilai: po_wo_dtl_pph[indexing].nilai,
          //     pemakaian: po_wo_dtl_pph[indexing].pemakaian,
          //     qty: po_wo_dtl_pph[indexing].qty,
          //     sisa: po_wo_dtl_pph[indexing].sisa,
          //     sisa_ori: po_wo_dtl_pph[indexing].sisa_ori,
          //     type_tax: po_wo_dtl_pph[indexing].type_tax,
          //     unit_price: po_wo_dtl_pph[indexing].unit_price,
          //   });
          // }

          const detils = _.filter(
            this.po_wo_dtl,
            (el) => el.type_tax == null || !el.type_tax.includes("pph")
          );
          // detils.forEach((element) => {
          //   console.log(element);
          // });
          for (let dex = 0; dex < detils.length; dex++) {
            // if (
            //   detils[index].document_tax != null &&
            //   detils[index].document_tax != "No File Uploaded"
            // ) {
            //   let typefile = this.fileTypeFromUrl(detils[index].document_tax);
            //   let file = this.dataURLtoFile(
            //     typefile + detils[index].document_file,
            //     detils[index].document_tax
            //   );
            //   file.uid = "vc-upload-1-1";
            //   file.status = "done";
            //   file.url = this.$serviceUrl + detils[index].document_path;
            //   detils[index]["attachment"] = file;
            // }

            detils[dex].attachment = null;
            detils[dex].nama_item = detils[dex].item;
            detils[dex].note = "";
            detils[dex].powo_nm = detils[dex].item;
            detils[dex].powopdtl = detils[dex].id_invoice_ap_ad_dtl;
            detils[dex].quantity = detils[dex].qty;
            detils[dex].used_for =
              detils[dex].kategori == "0" ? "1" : detils[dex].kategori;
            detils[dex].value = detils[dex].unit_price;
          }
          Event.$emit("updateList", { value: detils, type: "delete" });
        }
      });
  },
  methods: {
    moment,
    handleRemoveList() {
      this.form.file = undefined;
      this.fileList = [];
      this.$nextTick(() => {
        this.disabledUpload = false;
      });
    },
    beforeUpload(file) {
      //console.log(this.form.file,file)
      this.form.file = [file];
      this.fileList = [];
      this.fileList.push(file);
      this.$nextTick(() => {
        this.disabledUpload = true;
      });
      return false;
    },
    handleRef() {
      this.$refs.apform.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        if(this.moment(this.form.dateOfInvoice).format('YYYY-MM-DD')>this.moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Date of AP can't exceed today!");
          return;
        }
        //console.log("handleRef")

        // if (Array.isArray(values.dokumen)) {
        //     if(values.dokumen.length > 0){
        //         if (values.dokumen[0].includes(",")) {
        //             values.dokumen.shift();
        //         }
        //     }
        // }

        let data = {};
        data.tlc = this.getAuth.username;
        data.date_of_ap = this.moment(
          this.form.dateOfAp,
          this.getDefaultDateFormat
        ).format(this.getStandartFormatDate);
        data.jenis_transaksi = this.type;
        data.no_po_wo_addendum = this.form.idTransaksi;
        data.supplier = this.form.supplierId;
        data.no_invoice = this.form.invoice;
        data.description = this.form.deskripsi;
        data.no_rekening = this.form.bank.rekening;
        data.bank = this.form.bank.nama;
        data.kurs = this.form.kurs;
        data.date_of_invoice = this.moment(this.form.dateOfInvoice).format(
          this.getStandartFormatDate
        );
        data.due_date = this.moment(this.form.dueDate).format(
          this.getStandartFormatDate
        );
        data.value = this.form.value;
        data.note = this.form.note;
        data.nama_document = this.form.file;
        data.mata_uang = this.form.mata_uang;

        Event.$emit("apData", {
          informasi: data,
          listData: this.listData ? this.listData : {},
          files: this.form.file,
          po_wo_dtl: this.po_wo_dtl,
        });
      });
    },
    handleSubmit() {
      this.$refs.apform.validate((valid) => {
        if (!valid) {
          //console.log("tidak valid");
          return;
        }

        let data = new FormData();
        data.append("tlc", this.getAuth.username);
        data.append(
          "date_of_ap",
          this.moment(this.form.dateOfAp, this.getDefaultDateFormat).format(
            this.getStandartFormatDate
          )
        );
        data.append("jenis_transaksi", this.type);
        data.append("no_po_wo_addendum", this.form.idTransaksi);
        data.append("supplier", this.form.supplierId);
        data.append("no_invoice", this.form.invoice);
        data.append("description", this.form.deskripsi);
        data.append("no_rekening", this.form.bank.rekening);
        data.append("bank", this.form.bank.nama);
        data.append(
          "date_of_invoice",
          this.moment(this.form.dateOfInvoice).format(
            this.getStandartFormatDate
          )
        );
        data.append(
          "due_date",
          this.moment(this.form.dueDate).format(this.getStandartFormatDate)
        );
        data.append("value", this.form.value);
        data.append("note", this.form.note);
        data.append("nama_document", this.form.file[0]);

        this.$store
          .dispatch("createAP", {
            auth: this.getAuth,
            data: data,
          })
          .then((res) => {
            this.displayMessage("success-save");
            this.$router.push({ name: "account-pay-index" });
          })
          .catch((err) => {
            this.displayMessage("error");
            this.$router.go();
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  background-color: white;
  flex: 1;
  display: flex;
  height: 100%;
  flex-direction: column;

  &-header {
    height: 50px;
    border-bottom: 1px solid darken(white, 10);
    display: flex;
    align-items: center;
    padding: 0 @padding;
  }

  &-body {
    flex: 1;
    padding: @padding;
  }

  &-footer {
    border-top: 1px solid darken(white, 10);
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: @padding;
  }
}
</style>
